<template>
  <div class="vis-box-container" v-loading="loading">
    <div class="vis-box" ref="visContainer"></div>
    <showDetail ref="showDetail" :detail="detail" @close="detail = null" />
  </div>
</template>
<script>
import * as vis from 'vis-network'
import { DataSet } from 'vis-data'
import 'vis-network/styles/vis-network.css'
import showDetail from './showDetail.vue'
export default {
  name: 'VisIndex',
  components: {
    showDetail
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    showDetail: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      detail: null,
      loading: false
    }
  },
  mounted () {
    this.initVis()
  },
  beforeDestroy () {
    this.network?.destroy()
    if (window.gc) window.gc() // Chrome强制垃圾回收
  },
  watch: {
    data: {
      handler (val) {
        // 手动清理内存
        this.network && this.network.body.data.nodes.clear()
        this.network && this.network.body.data.edges.clear()
        this.initVis()
      },
      deep: true
    }
  },
  methods: {
    initVis () {
      if (this.data) {
        if ((this.data.data || []).length) {
          this.loading = true
        }
        const list = (this.data.data || []).map(e => ({
          id: e.Id,
          label: e.Name,
          group: e.labels
        }))
        // 创建节点和边数据
        const nodes = new DataSet(list)
        // 关系
        const edges = new DataSet(this.data.link.map(e => ({
          from: e.source,
          to: e.target,
          label: e.value
        })))
        // 配置选项
        const options = {
          physics: {
            enabled: true, // 必须启用物理引擎
            stabilization: {
              iterations: 200, // 增加稳定化迭代次数
              updateInterval: 100,
              onlyDynamicEdges: false,
              fit: true
            },
            barnesHut: {
              gravitationalConstant: -35000, // 增强排斥力（负值）
              centralGravity: 0.3,
              springLength: 150, // 增加弹簧基础长度
              springConstant: 0.02, // 降低弹簧刚度
              damping: 0.15, // 增加阻尼减少震荡
              avoidOverlap: 0 // 启用节点防重叠
            },
            maxVelocity: 10, // 限制最大运动速度
            minVelocity: 0.1 // 设置最小停止速度
          },
          layout: {
            improvedLayout: true // 启用优化布局算法
            // hierarchical: {
            //   enabled: false, // 根据需求选择是否启用层级布局
            //   direction: 'UD' // 如果启用可设置方向：UD, DU, LR, RL
            // }
          },
          nodes: {
            // 启用仅渲染可视区域节点
            shape: 'box',
            size: 50,
            margin: 20,
            // borderRadius: 50,
            font: {
              size: 16,
              color: '#987443',
              strokeWidth: 0
            },
            borderWidth: 0,
            shadow: true,
            scaling: {
              min: 20, // 最小尺寸
              max: 60, // 最大尺寸
              label: { // 文字自适应
                enabled: true,
                min: 14,
                max: 24,
                maxVisible: 24,
                drawThreshold: 8
              }
            }
          },
          groups: {
            Person: {
              color: {
                background: '#F78A36',
                border: '#F78A36',
                highlight: {
                  background: '#F78A36',
                  border: '#F78A36'
                }
              },
              font: {
                size: 14,
                color: '#ffffff'
              },
              margin: 15,
              shapeProperties: {
                borderRadius: 100 // 圆角
              }
            },
            Address: { // 实体节点
              color: {
                background: '#2868F4',
                border: '#2868F4',
                highlight: {
                  background: '#2868F4',
                  border: '#2868F4'
                }
              },
              font: {
                size: 14,
                color: '#ffffff'
              },
              margin: 15,
              shapeProperties: {
                borderRadius: 100 // 圆角
              }
            },
            Biographie: { // 属性节点
              color: {
                background: '#F5364B',
                border: '#F5364B',
                highlight: {
                  background: '#F5364B',
                  border: '#F5364B'
                }
              },
              font: {
                size: 14,
                color: '#ffffff'
              },
              margin: 15,
              shapeProperties: {
                borderRadius: 100 // 圆角
              }
            },
            RecordedIn: { // 属性节点
              color: {
                background: '#F5364B',
                border: '#F5364B',
                highlight: {
                  background: '#F5364B',
                  border: '#F5364B'
                }
              },
              font: {
                size: 14,
                color: '#ffffff'
              },
              margin: 15,
              shapeProperties: {
                borderRadius: 100 // 圆角
              }
            }
          },
          // hierarchical: {
          //   enabled: true,
          //   direction: 'LR', // 从左到右布局
          //   levelSeparation: 500, // 层级间距
          //   nodeSpacing: 500, // 同级节点间距
          //   treeSpacing: 500 // 不同树间距
          // },
          edges: {
            // arrows: 'to',
            // smooth: {
            //   type: 'cubicBezier',
            //   forceDirection: 'horizontal'
            // }
          },
          interaction: {
            hover: true,
            tooltipDelay: 200
          }
        }

        // 创建网络
        this.network = new vis.Network(
          this.$refs.visContainer,
          { nodes, edges },
          options
        )
        this.network.setOptions({ physics: false })
        this.network.stabilize(200)
        this.network.on('stabilizationIterationsDone', () => {
          this.loading = false
        })
        if (this.showDetail) {
          this.network.on('click', (e) => {
            if (e && e.nodes && e.nodes.length) {
              this.detail = [
                ...this.data.data
              ].find(d => d.Id === e.nodes[0])
            } else {
              this.$refs.showDetail.close()
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>
.vis-box-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.vis-box {
  width: 100%;
  height: 100%;
}
</style>
